(function() { window.GUID_3faf8e1d_e4a7_455f_95c0_fb8686327d44 = { getGuid: function() { return "3faf8e1d-e4a7-455f-95c0-fb8686327d44"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class DropDown extends Controls.List {
            constructor() {
                super(...arguments);
                this.preventClose = false;
            }
            get ParentDropDown() {
                if (this.CurrentPicker) {
                    return this.CurrentPicker.ParentDropDown;
                }
                return null;
            }
            isDescendantOf(dropdown) {
                let parent = this.ParentDropDown;
                if (parent == dropdown) {
                    return true;
                }
                if (parent) {
                    return parent.isDescendantOf(dropdown);
                }
                return false;
            }
            OnDispose() {
                this.Close();
                CS.Helper.DropDownInstances.OnDispose(this.ControlId);
                CS.Helper.DropDownInstances.RemoveInstance(this);
                super.OnDispose();
                this.$Control.remove();
            }
            get ControlId() {
                return this.$DropDown.attr("id");
            }
            get $Control() {
                return this.$DropDown;
            }
            Is(selector) {
                if (selector == this) {
                    return true;
                }
                else if (this.$DropDown.is(selector)) {
                    return true;
                }
                return false;
            }
            get PreventClose() {
                return this.preventClose;
            }
            set PreventClose(value) {
                this.preventClose = value;
            }
            OnControlInstantiation(params) {
                let ctlId = params[0];
                this.$DropDown = $("#" + ctlId + ":not(.inbody)");
                this.appendToBody();
                CS.Helper.DropDownInstances.AddInstance(this);
                this.$DropDown.data("dropdown", this);
                this.Parameters = this.$DropDown.data("parameters");
                let containerParams = [this.$DropDown];
                super.OnControlInstantiation(containerParams);
                this.preventCloseFromPop = false;
                this.locatePickers();
                CS.DOM.$body.trigger("dropdown-appended", this);
            }
            appendToBody() {
                let overlay = $();
                let existing = CS.DOM.$body.find("#" + this.ControlId + ".inbody");
                if (existing.length > 0) {
                    existing.remove(); //Si deja dans le body, exemple, un refresh ajax, on doit l'enlever
                }
                if (overlay.length > 0) {
                    this.$DropDown.appendTo(overlay);
                }
                else {
                    this.$DropDown.appendTo($("#section-master"));
                    //this.$DropDown.appendTo(CS.DOM.$body);
                }
                this.$DropDown.addClass("inbody");
            }
            locatePickers() {
                let me = this;
                let dataToFind = "[data-pickerof='" + me.ControlId + "']";
                let pickers = $(dataToFind);
                this.Pickers = new Array();
                $.each(pickers, function () {
                    let $this = $(this);
                    me.Pickers.push(new Controls.DropDownPicker(me, $this));
                });
            }
            OnKeyDown(e) {
                super.OnKeyDown(e);
                let keyPressed = CS.GetKeyPressed(e);
                if (keyPressed == CS.Enums.KeyCode.Enter ||
                    keyPressed == CS.Enums.KeyCode.Escape) {
                    //this.Hide();
                }
            }
            OnRefreshed() {
                super.OnRefreshed();
                this.RefreshDropDownLayout();
            }
            OnItemClicked($item, e) {
                super.OnItemClicked($item, e);
                const pickerId = this.CurrentPicker.$Picker.attr("id");
                if (pickerId) {
                    const isEventDropdown = pickerId.includes("cs-event-dropdown");
                    if (isEventDropdown) {
                        const _eventId = $item.attr("data-value");
                        const eventId = Number(_eventId);
                        CS.Analytics.Event("Events", "Event dropdown item clicked", `Event id - ${eventId}`, isNaN(eventId) ? undefined : eventId);
                    }
                }
                if (!this.Parameters.StayOpenOnSelection) {
                    this.Close();
                }
            }
            OnBindEvents() {
                super.OnBindEvents();
                let me = this;
                CS.Helper.DropDownInstances.BindEvents(this.ControlId);
            }
            OnSelectionChanged() {
                //important de laisser cette fonction vide pour empecher un selection changed pendant que la liste est ouverte
            }
            OnItemsFiltered(callback) {
                super.OnItemsFiltered(callback);
                if (this.IsVisible) {
                    this.RefreshDropDownLayout();
                }
                else {
                    this.Show(this.CurrentPicker);
                }
            }
            SetCurrentPicker(picker) {
                this.CurrentPicker = picker;
                if (this.CurrentPicker.IsAnInput && !this.CurrentPicker.IsASearchBox) {
                    this.$SearchBox = picker.$Picker;
                    this.CurrentPicker.ConvertToSearchBox();
                    this.$List.addClass("no-search-box");
                }
            }
            GetAndShow(url, data, picker) {
                let me = this;
                if (url) {
                    this.Parameters.RefreshUrl = url;
                }
                this.RefreshContent(data, function () {
                    me.Show(picker);
                });
            }
            PassItemsThroughFilterAndShow(picker) {
                let me = this;
                me.PassItemsThroughFilter(() => {
                    me.Show(picker);
                });
            }
            RefreshDropDownLayout(noLag = true) {
                var _a;
                let me = this;
                if (!me.IsVisible) {
                    return;
                }
                if (me.Parameters.DrawerStyle) {
                }
                else {
                    if (noLag) {
                        CS.Helper.PositionElementBasedOnOther(
                        // me.CurrentPicker.$Picker,
                        ((_a = me.$OverrideDropdownPositionReferenceElement) === null || _a === void 0 ? void 0 : _a.length)
                            ? me.$OverrideDropdownPositionReferenceElement
                            : me.CurrentPicker.$Picker, me.$DropDown, me.Parameters.FitWidthBasedOnReference, me.Parameters.PositionLeftByDefault, me.Parameters.ForceOpenBelow);
                        if (!me.CurrentPicker.IsASearchBox) {
                            me.RefreshSearchBoxUI();
                        }
                    }
                    else {
                        CS.Lag("RefreshDropDownLayout", 250, function () {
                            var _a;
                            if (me.IsVisible) {
                                CS.Helper.PositionElementBasedOnOther(
                                // me.CurrentPicker.$Picker,
                                ((_a = me.$OverrideDropdownPositionReferenceElement) === null || _a === void 0 ? void 0 : _a.length)
                                    ? me.$OverrideDropdownPositionReferenceElement
                                    : me.CurrentPicker.$Picker, me.$DropDown, me.Parameters.FitWidthBasedOnReference, me.Parameters.PositionLeftByDefault, me.Parameters.ForceOpenBelow);
                                if (!me.CurrentPicker.IsASearchBox) {
                                    me.RefreshSearchBoxUI();
                                }
                            }
                        });
                    }
                }
            }
            arrayAreEquals(arrayA, arrayB) {
                let arrayALength = arrayA ? arrayA.length : 0;
                let arrayBLength = arrayB ? arrayB.length : 0;
                if ((!arrayA && !arrayB) || (arrayALength === 0 && arrayBLength === 0)) {
                    return true;
                }
                else {
                    if (arrayALength !== arrayBLength) {
                        return false;
                    }
                    else {
                        for (var i = 0; i < arrayA.length; i++) {
                            let valueA = arrayA[i];
                            let valueB = arrayB[i];
                            if (valueA.value != valueB.value) {
                                return false;
                            }
                            if (valueA.innerText != valueB.innerText) {
                                return false;
                            }
                        }
                        return true;
                    }
                }
            }
            Close(picker) {
                let me = this;
                me.preventCloseFromPop = true;
                setTimeout(function () {
                    me.preventCloseFromPop = false;
                }, 300);
                if (!this.PreventClose) {
                    if (me.StayOpenMomentary) {
                        me.StayOpenMomentary = false;
                        return;
                    }
                    if ((picker != null && !me.Parameters.AllowCloseDropDownFromPicker) ||
                        !me.IsVisible) {
                        return;
                    }
                    const $overlay = $(`#dropdown-overlay-${me.ControlId}`);
                    if ($overlay.length > 0) {
                        $overlay.remove();
                    }
                    CS.PopState.GoBackIfNotAlreadyDone();
                    if (picker != null) {
                        picker.TextSelected = false;
                    }
                    if (me.CurrentPicker != null) {
                        me.CurrentPicker.TextSelected = false;
                    }
                    me.IsVisible = false;
                    if (me.Parameters.DrawerStyle) {
                        me.$DropDown.css({ transform: "translateX(100%)" });
                        CS.Lag("dropdown-drawer-style-collapse", 250, () => {
                            me.$DropDown.hide();
                        });
                    }
                    else {
                        me.$DropDown.slideUp(150);
                    }
                    if (!me.arrayAreEquals(me.CurrentPicker.Datas, me.SelectedDatas)) {
                        me.CurrentPicker.OnSelectionChange(me.SelectedDatas);
                    }
                    if (me.needToReactivatePulltoRefresh) {
                        me.needToReactivatePulltoRefresh = false;
                        CS.PullToRefresh.Current.Disabled = false;
                    }
                }
            }
            protectAgainstPopStatePatch() {
                let me = this;
                //Ce preventClose sert au WaitForPop. Quand on clique sur un autre dropdown, le HideOtherInstances est appelé
                //et vue quil y a un petit lag sur le window.history.back, ben il ferme lui meme. Ainsi, en mettons un petit lag
                //je m'assure quel ne se ferme pu si callé par lui meme
                if (!me.PreventClose) {
                    me.PreventClose = true;
                    setTimeout(function () {
                        me.PreventClose = false;
                    }, 500);
                }
            }
            Show(picker) {
                let me = this;
                const { ShowOverlay, DrawerStyle } = me.Parameters;
                if (me.IsVisible && me.CurrentPicker && me.CurrentPicker == picker) {
                    return;
                }
                if (ShowOverlay) {
                    // Prepend an element right before me.$Control
                    let $overlay = $(`<div id="dropdown-overlay-${me.ControlId}" class="dropdown-overlay"></div>`);
                    $overlay.insertBefore(me.$Control);
                    $overlay.offon("click.dropdownOverlay", (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        $overlay.remove();
                    });
                }
                if (CS.PullToRefresh.Current &&
                    CS.PullToRefresh.Current.Disabled == false) {
                    me.needToReactivatePulltoRefresh = true;
                    CS.PullToRefresh.Current.Disabled = true;
                }
                CS.DOM.$body.offon("ajaxnavigating." + me.ControlId, () => {
                    me.Close();
                });
                //let preventCloseFromPop = false;
                me.preventClose = true;
                setTimeout(function () {
                    CS.PopState.WaitForPop(me.ControlId, function () {
                        //Je remplace ce que protectAgainstPopStatePatch faisait mais mieux
                        //preventCloseFromPop = true;
                        if (!me.preventCloseFromPop) {
                            me.Close();
                        }
                    });
                    me.preventClose = false;
                }, 100);
                //me.protectAgainstPopStatePatch();
                let alreadyVisible = me.IsVisible;
                me.IsVisible = true;
                me.SetCurrentPicker(picker);
                me.SelectItemsBasedOnDatas(me.CurrentPicker.Datas);
                CS.Helper.DropDownInstances.HideOtherInstances(me);
                me.RefreshDropDownLayout();
                //Il est possible que Show soit caller par un autre picker que le précédent et au lieu de refaire un slidedown
                //je laisse passé tout le reste dont le refresh de la position mais je ne call pas le slidedown pour éviter un glitch visuel
                if (!alreadyVisible) {
                    if (DrawerStyle) {
                        me.$DropDown.show();
                        CS.Lag("dropdown-drawer-style-expand", 100, () => {
                            me.$DropDown.css({ transform: "translateX(0)" });
                        });
                    }
                    else {
                        me.$DropDown.slideDown(150, function () {
                            if (!me.CurrentPicker.IsASearchBox) {
                                me.RefreshSearchBoxUI();
                                me.FocusContainer();
                            }
                            me.ScrollToLastSelectedItem();
                        });
                    }
                }
                else {
                    me.FocusContainer();
                }
            }
        }
        Controls.DropDown = DropDown;
        (function (DropDown) {
            class Events extends CS.Controls.DropDownPicker.Events {
                static Appended(param) {
                    Controls.RegisterEvent(DropDown, EventNames.Appended, param);
                }
            }
            DropDown.Events = Events;
            class EventNames {
            }
            EventNames.Appended = "dropdown-appended";
            DropDown.EventNames = EventNames;
        })(DropDown = Controls.DropDown || (Controls.DropDown = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=dropdown.js.map
